import { dataFeedbackSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFeedbackSolid = /*#__PURE__*/createIcon(dataFeedbackSolid)
export default IconFeedbackSolid
